import { isValid } from 'date-fns';
import { ISO_DATE_PREFIX } from '../../../../constants';

// Accept only ISO date/datetime shapes so loosely-coercible junk (e.g. "1", "2001") is rejected instead of becoming a bogus date.
export const parseIsoDateValue = (value: string): Date | null => {
  const trimmed = value.trim();
  if (!ISO_DATE_PREFIX.test(trimmed)) return null;

  const parsed = new Date(trimmed);
  return isValid(parsed) ? parsed : null;
};
